import { render, staticRenderFns } from "./Cybersafe.vue?vue&type=template&id=456af030&scoped=true"
import script from "./Cybersafe.vue?vue&type=script&lang=js"
export * from "./Cybersafe.vue?vue&type=script&lang=js"
import style0 from "./Cybersafe.vue?vue&type=style&index=0&id=456af030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456af030",
  null
  
)

export default component.exports